// A turn's working output (D82) as one Thinking row (S137): streamed thinking and partial text,
// the agent's interim messages and one line per tool call, pulsing while the turn runs and opened
// in a dialog on demand. It never holds the conversation up.
import { groupThoughts, type ThinkingGroup } from "../conversation/thinking";
import { ThinkingRow } from "../conversation/ThinkingRow";
import { ACTIVE } from "./api";
import type { TurnEntry } from "./model";

function turnThinking(entry: TurnEntry): ThinkingGroup | undefined {
  const live = ACTIVE.includes(entry.turn.status);
  // The reply follows the working output, so its text drops the partials it repeats.
  const group = groupThoughts([...entry.progress, ...entry.replies], entry.turn.id, { interim: true, live });
  if (group) return group;
  // A queued turn has nothing to show yet; one that ran without output needs no row.
  return live && entry.turn.status !== "queued" ? { key: entry.turn.id, thoughts: [], updates: 0, live } : undefined;
}

export function TurnProgress({ entry }: { entry: TurnEntry }) {
  const group = turnThinking(entry);
  return group ? <ThinkingRow group={group} className="ms-11" testId="chat-progress" /> : null;
}
